import { render, staticRenderFns } from "./RuleValueTable.vue?vue&type=template&id=ed7a0a62&scoped=true"
import script from "./RuleValueTable.vue?vue&type=script&lang=js"
export * from "./RuleValueTable.vue?vue&type=script&lang=js"
import style0 from "./RuleValueTable.vue?vue&type=style&index=0&id=ed7a0a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7a0a62",
  null
  
)

export default component.exports